export const useLanguage = () => 'en'
